import React, { useState } from 'react';
import InputForm from '../../InputT';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../Types/ParamsPicklist';
import { Box } from '@mui/material';
import { Button, Spin } from 'antd';
import Table from '../../TableResizable';
import { SwipeUp } from '@mui/icons-material';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../Models/Utilisateur';
import SearchInput from '../../SearchInput';
import { ColumnsType } from 'antd/es/table';
import axios from 'axios';
import { Crypter } from '../../../Functions/Security/Crypter';
import DataType from '../../../Types/DataTablePiclist';
import Datas from '../../../Data/Data.json'
import File from '../../File';
import DataTypeTable from '../../../Types/DataTypeTable';
import SearchModal from '../../SearchModal';

const columns: ColumnsType<DataTypeTable> = [
  {
    title: 'N° Carte',
    dataIndex: 'NUMIDENTI',
  },
  {
    title: 'Nom Avaliste',
    dataIndex: 'codgar',
  },
  {
    title: 'Téléphone',
    dataIndex: 'LOCAL',
  },
  {
    title: 'Adresse',
    dataIndex: 'VALGARANTI',
  },
  {
    title: 'Date de naissance',
    dataIndex: 'DESIGNATION',
  },
  {
    title: 'Revenu mensuelle',
    dataIndex: 'DATDEB',
  },
  {
    title: 'Date Fin',
    dataIndex: 'DATFIN',
  },
  {
    title: 'Commentaire',
    dataIndex: 'TEXTCOMMEN',
  }
];

let searchUser: Params = { CodeAgence: '', Table: "UTILIS", Colonne1: "CODUTI", Colonne2: "NOMUTI", Colagence: '001', Choix: 22 }


let searchTypAdr: Params = { CodeAgence: '', Table: "UTILIS", Colonne1: "CODUTI", Colonne2: "NOMUTI", Colagence: '001', Choix: 22 }



//Initialisation des parametres de recherche
let searchTitre: Params = { CodeAgence: '', Table: "TITRES", Colonne1: "CDTITR", Colonne2: "LIBELL1", Colagence: '101', Choix: 22 }
let searchSituationFamiliale: Params = { CodeAgence: "SITFAM", Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }
let searchProspect: Params = { CodeAgence: '', Table: "DEMARC", Colonne1: "CODDMR", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchClassRisque: Params = { CodeAgence: '', Table: "CLARIS", Colonne1: "CLARIS", Colonne2: "LIBELLFR", Colagence: '101', Choix: 22 }
let searchPays: Params = { CodeAgence: '', Table: "CDPAYS", Colonne1: "CDPAYS", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchActivite: Params = { CodeAgence: '', Table: "TABNAE", Colonne1: "CODNAE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchUniteInstitutionnel: Params = { CodeAgence: '', Table: "TABNUI", Colonne1: "CODNUI", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchRegimeMatrimonial: Params = { CodeAgence: "REGMAT", Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }
//
let searchNiveauInstruction: Params = { CodeAgence: '', Table: "INSTRU", Colonne1: "CODINS", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchEthnie: Params = { CodeAgence: '', Table: "ETHNIE", Colonne1: "CODETH", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchCateGo: Params = { CodeAgence: '', Table: "CATEGO", Colonne1: "CATEGO", Colonne2: "LIBELLFR", Colagence: '101', Choix: 22 }
let searchZoneGeo: Params = { CodeAgence: '', Table: "RESIDE", Colonne1: "CDRESI", Colonne2: "LIBELLFR", Colagence: '101', Choix: 22 }
let searchCpt: Params = { CodeAgence: '', Table: "AGENCE", Colonne1: "plc2", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchGroup: Params = { CodeAgence: '', Table: "GROUPUSER", Colonne1: "CODGROUP", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchGes: Params = { CodeAgence: '', Table: "GESTIONNAIRE", Colonne1: "CODGES", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchService: Params = { CodeAgence: '', Table: "SERVICE", Colonne1: "CODSERV", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchIndice: Params = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 }
let searchCompte: Params = { CodeAgence: '', Table: "CCOMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: '101', Choix: 22 }
let searchStatus: Params = { CodeAgence: '', Table: "Status", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchGroupUtilis: Params = { CodeAgence: '', Table: "GROUPUSER", Colonne1: "CODGROUP", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchGarantie: Params = { CodeAgence: '', Table: "V_CGARANTIE", Colonne1: "", Colonne2: "", Colagence: '101', Choix: 3 }
let searchTypeGrantie: Params = { CodeAgence: '', Table: "TYPEGARANTIE", Colonne1: "CODGAR", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchGarantieForm: Params = { CodeAgence: '', Table: "V_CGARANTIE", Colonne1: "NUMIDENTI", Colonne2: "DESIGNATION", Colagence: '101', Choix: 22 }

//let searchRelation: Params = { CodeAgence: '', Table: "RELATION", Colonne1: "IDCLIENT", Colonne2: "", init:'numcli', Colagence: '101', Choix: 3 }



function Tab1(props: { form?: any }) {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))


  // USER TOKEN
  const authHeader = useAuthHeader()
 


  // const [loading, setLoading] =React.useState(false);
  // const [loadData, setLoadData] = useState(false)

  // const ThemeTable = styled(Table)(({ theme }) => ({

  //   ".ant-table-body ": {
  //     height : '185px',
  //     borderBottom : '1px var(--colorOpaque020) solid',
  //   }

  //   }
  // ));




  // if (loadData) {
  //   setLoadData(false)

  //   setLoading(true);
  //   setScrool({ y:250, x:10})

  //   //var data = {CodeAgence:searchGarantie?.CodeAgence,Table:props.Parametre?.Table,Colonne1:props.Parametre?.Colonne1,Colonne2:props.Parametre?.Colonne2,Colagence:props.Parametre?.Colagence,Init:values.text,choix:props.Parametre?.Choix}

  //   var config = {
  //     method: 'get',
  //     maxBodyLength: Infinity,
  //     url: Datas.ApiUrl.AnySearch,
  //     headers: { 
  //       'Content-Type': 'application/json',
  //       'Authorization': authHeader(),
  //       'CipherSearch': Crypter.encrypt(JSON.stringify(searchGarantie))
  //     }
  //   }; 
  //   axios(config)
  //   .then((response)=>{
  //   console.log(response.data)
  //   if(response.data){
  //     const res = JSON.parse(Crypter.decrypt(response.data)).Value;
  //     const datat: DataTypeTable[] = [];

  //     if(res.StatutCode == 200){
  //       let datas = res.Result.Table;
  //       console.log(datas)

  //       if(datas.length===0){
  //         //console.log("aucun élément ");
  //         SetData([])
  //       }
  //       else{
  //         datas.map((data : any, indice: number)=>{
  //           //console.log(JSON.stringify(data))
  //           datat.push({
  //             key: indice,
  //             NUMIDENTI: data.NUMIDENTI,
  //             NUMCLI: data.NUMCLI,
  //             lib_NUMCLI: data.lib_NUMCLI,
  //             codgar: data.codgar,
  //             lib_codgar: data.lib_codgar,
  //             LOCAL: data.LOCAL,
  //             VALGARANTI: data.VALGARANTI,
  //             DESIGNATION: data.DESIGNATION,
  //             DATDEB: data.DATDEB,
  //             DATFIN: data.DATFIN,
  //             TEXTCOMMEN: data.TEXTCOMMEN,
  //             fichier: data.fichier,
  //           });
  //           SetData(datat);  
  //         })
  //         //setScrool(undefined)
  //       }
  //     }
  //   }
  //   setLoading(false);
  //   }).catch((error)=>{
  //     console.log(error)
  //     setLoading(false);
  //     // SweetAlert.fire({title: "Error", text : error})
  //   })
  // }

  return (
    <div className='tabItem'>
      <div >
        <Box fontStyle="inherit" className='border border-left' width={"85%"} position={"absolute"}>
          <Box display={"flex"} fontStyle="inherit" >
            <Box fontStyle="inherit" >
              <SearchInput width={9} form={props.form} Titre='Recherche Client' label='Indice Client' name='NUMCLI' Parametre={searchIndice} />
               <SearchInput width={9} form={props.form} Titre='Recherche relation' label='Id relation' name='IDRELATION' Parametre={searchIndice} />

              <InputForm width={9} label="Carte d'identité" type={'text'} name='CIDENTITE' />
              <InputForm width={9} label='Délivré le' icon={<SwipeUp color='disabled' fontSize='small' />} name='DATEDEL' type='date' error='mobile' />
              <InputForm width={9} label='à' icon={<SwipeUp color='disabled' fontSize='small' />} name='LIEUDEL' type='text' error='mobile' />
              <InputForm width={9} label='Nom avaliste' type={'text'} name='DESIGNATION' />
            </Box><hr />
            <Box fontStyle="inherit" >
              <InputForm width={9} label='Téléphone' type={'text'} name='TELEPH1' />
              <InputForm width={9} label='Profession' icon={<SwipeUp color='disabled' fontSize='small' />} name='PROFESSION' type='TEXT' error='mobile' />
              <Box fontStyle={"inherit"} display={"flex"}>
                <InputForm width={6} label='Date naisssance' icon={<SwipeUp color='disabled' fontSize='small' />} name='DATNAIS' type='date' error='mobile' />
                <InputForm width={5} label='Lieu naissance' icon={<SwipeUp color='disabled' fontSize='small' />} name='LIEUNAIS' type='TEXT' error='mobile' />
              </Box>
              <InputForm width={9} label='Adresse Avaliste' icon={<SwipeUp color='disabled' fontSize='small' />} name='ADRESS' type='text' error='mobile' />
              <InputForm width={9} label='Revenue Mensuelle' icon={<SwipeUp color='disabled' fontSize='small' />} name='REVENU' type='number' error='mobile' />
            </Box>
          </Box>
        </Box>
      </div>
    </div>
  )
}
export default Tab1;  
